import React from 'react';
import Footer from './../Components/Navbar/Footer';

/**
 * Lenox Paints - Terms and Conditions
 *
 * A responsive React component displaying placeholder terms and conditions text.
 * Styled with the specified colors: #ed3237 (primary red) and black.
 *
 * IMPORTANT: This is placeholder text. Replace it with the official terms
 * from the Lenox Paints website footer.
 */
const TermsConditions = () => {
  // Styles object using the specified color palette
  const styles = {
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '20px',
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, sans-serif',
      lineHeight: 1.6,
      color: '#000000',
      backgroundColor: '#ffffff',
    },
    header: {
      textAlign: 'center',
      marginBottom: '40px',
      padding: '20px 10px',
      borderBottom: `4px solid #ed3237`,
    },
    headerTitle: {
      fontSize: 'clamp(2rem, 5vw, 2.8rem)',
      fontWeight: '700',
      marginBottom: '10px',
      color: '#000000',
    },
    headerSubtitle: {
      fontSize: 'clamp(1rem, 3vw, 1.2rem)',
      color: '#333333',
      fontWeight: '300',
    },
    lastUpdated: {
      display: 'inline-block',
      margin: '15px 0',
      padding: '6px 16px',
      backgroundColor: '#f5f5f5',
      borderRadius: '30px',
      color: '#000000',
      border: '1px solid #e0e0e0',
    },
    policyCard: {
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      padding: '30px',
      boxShadow: '0 8px 30px rgba(0, 0, 0, 0.08)',
      border: '1px solid #eaeaea',
      marginBottom: '30px',
    },
    cardTitle: {
      fontWeight: '600',
      marginBottom: '25px',
      paddingBottom: '12px',
      borderBottom: `3px solid #ed3237`,
      color: '#000000',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    },
    sectionTitle: {
      fontWeight: '600',
      marginTop: '30px',
      marginBottom: '15px',
      color: '#000000',
    },
    text: {
      marginBottom: '18px',
      color: '#222222',
    },
    list: {
      margin: '10px 0 25px 25px',
      color: '#222222',
    },
    listItem: {
      marginBottom: '10px',
      listStyleType: 'disc',
      fontSize: '16px',
    },
    footnote: {
      marginTop: '30px',
      padding: '25px',
      backgroundColor: '#f8f8f8',
      borderRadius: '10px',
      textAlign: 'center',
      color: '#333333',
      borderLeft: `4px solid #ed3237`,
    },
    link: {
      color: '#ed3237',
      textDecoration: 'none',
      fontWeight: '500',
      borderBottom: '1px dotted #ed3237',
    },
    badge: {
      display: 'inline-block',
      padding: '4px 12px',
      backgroundColor: '#ed3237',
      color: '#ffffff',
      borderRadius: '20px',
      fontSize: '0.75rem',
      fontWeight: '600',
      letterSpacing: '0.5px',
      marginLeft: '10px',
    },
  };

  return (
    <div>
      <div style={styles.container}>
        {/* Main Terms and Conditions Content */}
        <div style={styles.policyCard}>
          <h2 style={styles.cardTitle}>Terms and Conditions</h2>
          <div style={styles.lastUpdated}>Last Updated: 09 March 2026</div>

          <p style={styles.text}>
            Welcome to Lenox Paints. By accessing our website and using our
            services, you agree to be bound by these Terms and Conditions.
            Please read them carefully.
          </p>

          <h3 style={styles.sectionTitle}>1. Acceptance of Terms</h3>
          <p style={styles.text}>
            By accessing or using the Lenox Paints website, you acknowledge that
            you have read, understood, and agree to be bound by these Terms and
            Conditions. If you do not agree, please do not use our website.
          </p>

          <h3 style={styles.sectionTitle}>2. Intellectual Property Rights</h3>
          <p style={styles.text}>
            All content on this website—including but not limited to product
            names (Cosmic, Rapid, Aerial, etc.), logos, brochures, images, and
            text—is the exclusive property of Lenox Paints or its licensors.
            Unauthorized use, reproduction, or distribution is strictly
            prohibited.
          </p>

          <h3 style={styles.sectionTitle}>3. Product Information</h3>
          <p style={styles.text}>
            We strive to display accurate product shades and specifications.
            However, actual paint colours may vary due to screen settings and
            monitor calibrations. We recommend testing with physical swatches
            before making purchasing decisions.
          </p>

          <h3 style={styles.sectionTitle}>4. Dealer Enquiries and Approvals</h3>
          <p style={styles.text}>
            Submitting a dealer enquiry does not guarantee empanelment or
            partnership. Lenox Paints reserves the sole right to evaluate,
            select, or reject any applicant at its discretion without providing
            any reason.
          </p>

          <h3 style={styles.sectionTitle}>5. Limitation of Liability</h3>
          <p style={styles.text}>
            To the maximum extent permitted by law, Lenox Paints shall not be
            liable for any indirect, incidental, special, consequential, or
            punitive damages arising from the use of this website or our
            products.
          </p>

          <h3 style={styles.sectionTitle}>6. Governing Law</h3>
          <p style={styles.text}>
            These Terms and Conditions are governed by the laws of India. Any
            disputes arising shall be subject to the exclusive jurisdiction of
            the courts in Bangalore.
          </p>

          <h3 style={styles.sectionTitle}>7. Changes to Terms</h3>
          <p style={styles.text}>
            We reserve the right to modify or update these Terms and Conditions
            at any time without prior notice. Continued use of the website
            after changes constitutes acceptance of the revised terms.
          </p>

          <h3 style={styles.sectionTitle}>8. Contact Information</h3>
          <p style={styles.text}>
            For questions regarding these Terms and Conditions, please contact
            us at: <strong>info@lenoxpaints.com</strong> or visit our registered
            office at:
            <br />
            #785, Ground Floor, 16th Main Road
            <br />
            23rd 'A' Cross, Near HSR Club
            <br />
            HSR Layout, 3rd Sector
            <br />
            Bangalore - 560102.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsConditions;